import { render, staticRenderFns } from "./MediaUploadSingle.vue?vue&type=template&id=10ddd3ff"
import script from "./MediaUploadSingle.vue?vue&type=script&lang=js"
export * from "./MediaUploadSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports